
import { computed, defineComponent, ref } from "vue";
import planetData from "@/data/data.json";
import { onBeforeRouteUpdate, useRoute } from "vue-router";

export default defineComponent({
  setup() {
    const route = useRoute();
    const name = ref(route.params.name);

    onBeforeRouteUpdate((to) => {
      name.value = to.params.name;
    });

    const planet = computed(() => {
      return planetData.find((p) => p.name.toLowerCase() === name.value);
    });

    const planetImage = computed(() => {
      return `../../assets/planet-${planet.value?.name.toLowerCase()}.svg`;
    });

    return { planet, planetImage };
  },
});
